import React from 'react';
import { Helmet } from "react-helmet";
import * as authActions from '../../store/auth/auth.actions';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Form, { FormElementMap } from './../../components/Form/Form';
import Error from './../../components/Error/Error';
import Spinner from '../../core/Spinner/Spinner';

const Forgot: React.FunctionComponent<{}> = () => {
    const dispatch = useDispatch();
    const { error, fetching, forgotRequested } = useSelector((state: any) => state.authStore);

    const onSubmit = (credentials: any) => {
        dispatch(authActions.requestPasswordReset({ credentials }));
    };

    const renderForm = () => {
        if (error) {
            return <Error />;
        }

        if (forgotRequested) {
            alert('Le hemos enviado un email para reiniciar su contraseña');
            return <Redirect to="/" />
        }

        if (fetching) {
            return <Spinner>Corroborando credenciales...</Spinner>
        }

        const formElements: FormElementMap[] = [{ 
            elementType: 'input', 
            id: 'E_MAIL', 
            placeholder: 'Correo Electrónico', 
            valueType: 'email', 
            required: true, 
            minLength: 8 
        }, { 
            elementType: 'input', 
            id: 'CUITCLI', 
            placeholder: 'CUIT', 
            valueType: 'text', 
            required: true, 
            minLength: 13,
            maxLength: 13 
        }];

        return (
            <Form 
                onSubmit={onSubmit}
                elements={formElements}
                name="authForm"
                submitText="Solicitar cambio de contraseña"
            />
        );
    };

    return (
        <div className="container SectionContainer">
            <Helmet>
                <title>Héctor Blejer | Olvidé mi contraseña</title>
                <meta name="description" content="Hector Blejer. Representaciones comerciales" />
                <meta name="keywords" content="Hector Blejer, hector, blejer, fabrica, fabricas, distribuidor, insumos, limpieza, representaciones comerciales, comercial, representacion, productos, negocios" />
            </Helmet>
            <h3 className="SectionTitle">Olvidé mi contraseña</h3>
            <div className="AuthFormContainer">{renderForm()}</div>
        </div>
    );
};

export default Forgot;